// extracted by mini-css-extract-plugin
module.exports = {"navArrow":"y9","navArrowSvg":"y-","wrapper":"y_","reverse":"za"};